import styled from "styled-components";

export const FiltersContainer = styled("div")`
  padding: 10px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;

  margin: 0px 0px;

  width: 100%; /* Adjust the width as needed */
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent the content from wrapping to the next line */

  /* Hide the scrollbar */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: transparent transparent; /* Firefox */

  /* Hide the scrollbar for other browsers (Chrome, Safari, Edge) */
  -ms-overflow-style: none; /* Internet Explorer and Microsoft Edge */
  scrollbar-width: none; /* Google Chrome, Safari, and Opera */
`;

export const Filter = styled("button")<{ active }>`
  padding: 0px 7px;
  margin: 0px;
  border: 0px;
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.Black25};
  background-color: ${({ active, theme }) =>
    active ? theme.colors.Primary : "transparent"}
  color: ${({ active, theme }) =>
    active ? theme.colors.Black : theme.colors.Primary};
  border-radius: 3px;
  cursor: pointer;
`;

export const ClearButton = styled("label")`

position: relative;
display: flex;
align-items: center;
cursor: pointer;
color: rgba(0, 0, 24, 0.84);
line-height: 16px;
z-index: 2;
padding: 0px 7px;
border-radius: 3px;
border: 1px solid rgba(210, 210, 210, 1);
font-size: 12px;
transition: all 0.3s ease, transform 0.3s ease;
`;
